import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-40c5aee9"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "input-editor-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_EditorContent = _resolveComponent("EditorContent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_EditorContent, {
            class: "prosemirror-wrapper",
            editor: _ctx.viewer,
            spellcheck: "false"
        }, null, 8, ["editor"])
    ]));
}
